import React from 'react';
import qs from 'qs';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { notifyError } from '../../../utils/notify';
import { selectValues } from '../../../utils/fc';
import oikosApi from '../../../services/oikos';
import Select from '../../Template/Input/Select';
import MaskedInput from '../../Template/Input/MaskedInput';
import InhireVagaKanban from './InhireVagaKanban';
import VagaHorarioKanban from './VagaHorarioKanban';

const CONTRACT_TYPES = [
  'CLT',
  'PJ',
  'Associado',
  'Contrato Temporário',
  'Cooperado',
  'Estágio',
  'Menor aprendiz',
  'Autônomo',
];

const SENIORITY_OPTIONS = [
  { value: 'junior', label: 'Júnior' },
  { value: 'mid-level', label: 'Pleno' },
  { value: 'senior', label: 'Sênior' },
  { value: 'specialist', label: 'Especialista' },
  { value: 'leadership', label: 'Liderança' },
];

const POSITION_REASONS = [
  { value: 'expansion', label: 'Aumento de quadro' },
  { value: 'replacement', label: 'Substituição' },
  { value: 'other', label: 'Outro' },
];

const JOB_STATUS_OPTIONS = [
  { value: 'open', label: 'Aberta' },
  { value: 'paused', label: 'Pausada' },
  { value: 'closed', label: 'Fechada' },
  { value: 'canceled', label: 'Cancelada' },
];

const POSTING_STATUS_OPTIONS = [
  { value: 'published', label: 'Pública' },
  { value: 'unlisted', label: 'Restrita' },
  { value: 'unpublished', label: 'Privada' },
];

const JOB_BOARDS = [
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'indeed', label: 'Indeed' },
  { value: 'netvagas', label: 'NetVagas' },
  { value: 'talent', label: 'Talent.com' },
  { value: 'catho', label: 'Catho' },
  { value: 'glassdoor', label: 'Glassdoor' },
];

const FORM_FIELDS = [
  { value: 'curriculum', label: 'Pedir anexo de currículo' },
  { value: 'linkedin', label: 'Pedir perfil do LinkedIn' },
  { value: 'salary', label: 'Pedir pretensão salarial' },
  { value: 'location', label: 'Pedir localização (país, estado, cidade)' },
  { value: 'workModel', label: 'Perguntar disponibilidade para o modelo de trabalho' },
  { value: 'referral', label: 'Pedir indicação' },
];

const JOB_PHASES = [
  { id: 'listing', templatePhaseId: '1', name: 'Listagem', phaseType: 'listing', stageType: 'listed' },
  { id: 'approach', templatePhaseId: '2', name: 'Abordagem', phaseType: 'approach', stageType: 'inApproach' },
  { id: 'application', templatePhaseId: '3', name: 'Candidatura', phaseType: 'application', stageType: 'applied' },
  { id: 'culturalFit', templatePhaseId: '4', name: 'Fit Cultural', phaseType: 'culturalFit', stageType: 'culturalInterview' },
  { id: 'technicalFit', templatePhaseId: '5', name: 'Avaliação Ecossis', phaseType: 'technicalFit', stageType: 'technicalInterview' },
  { id: 'offer', templatePhaseId: '6', name: 'Oferta', phaseType: 'offer', stageType: 'inOffer' },
  { id: 'hiring', templatePhaseId: '7', name: 'Contratação', phaseType: 'hiring', stageType: 'hired' },
];

const DEFAULT_STAGES = [
  { id: 'stage-hunting', templateStageId: '1', name: 'Hunting', phaseId: 'listing' },
  { id: 'stage-abordagem', templateStageId: '2', name: 'Abordagem', phaseId: 'approach' },
  { id: 'stage-candidatura', templateStageId: '3', name: 'Candidatura', phaseId: 'application' },
  { id: 'stage-triagem', templateStageId: '4', name: 'Triagem', phaseId: 'culturalFit' },
  { id: 'stage-entrevista', templateStageId: '5', name: 'Entrevista', phaseId: 'technicalFit' },
  { id: 'stage-entrevista-2', templateStageId: '6', name: 'Entrevista II', phaseId: 'technicalFit' },
  { id: 'stage-pre-selecao', templateStageId: '7', name: 'Pré seleção', phaseId: 'technicalFit' },
  { id: 'stage-oferta', templateStageId: '8', name: 'Oferta', phaseId: 'offer' },
  { id: 'stage-contratacao', templateStageId: '9', name: 'Contratação', phaseId: 'hiring' },
];

const orderStagesByPhase = (stages = []) => (
  JOB_PHASES.flatMap((phase) => stages.filter((stage) => stage.phaseId === phase.id))
);

const STAGE_TEMPLATE_AT = '2024-05-28T16:19:16.947Z';

const INHIRE_CUSTOM_FIELDS = [
  {
    key: 'projeto',
    name: 'Projeto',
    type: 'text',
    order: 1,
    customFieldId: 'job*383a63de-7bd4-4e40-87d8-4e1d2d8dea79*62a8c108-097e-4c40-ab75-048032fce255',
  },
  {
    key: 'formacao',
    name: 'Formação profissional ',
    type: 'text',
    order: 2,
    customFieldId: 'job*383a63de-7bd4-4e40-87d8-4e1d2d8dea79*df7b6980-f412-44f4-b0ef-0e14fc411a14',
  },
  {
    key: 'atestados',
    name: 'Atestados necessários: ',
    type: 'text',
    order: 3,
    customFieldId: 'job*383a63de-7bd4-4e40-87d8-4e1d2d8dea79*7482cb8b-4cf8-4636-93c1-8ed03e9bf0ec',
  },
  {
    key: 'equipeInterna',
    name: 'Equipe interna?',
    type: 'select',
    order: 4,
    customFieldId: 'job*383a63de-7bd4-4e40-87d8-4e1d2d8dea79*4f990a4c-f049-493d-a288-a48cb33304ff',
  },
  {
    key: 'tipoContratacaoCustom',
    name: 'Tipo de Contratação ',
    type: 'select',
    order: 5,
    customFieldId: 'job*383a63de-7bd4-4e40-87d8-4e1d2d8dea79*20526e9d-97bb-4435-a813-48ce7fe69713',
  },
];

const AREA_OPTIONS = [
  { value: 'customerSuccess', label: 'Customer Success' },
  { value: 'data', label: 'Dados' },
  { value: 'design', label: 'Design' },
  { value: 'engineering', label: 'Engenharia' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'operations', label: 'Operações' },
  { value: 'product', label: 'Produto' },
  { value: 'sales', label: 'Vendas' },
  { value: 'other', label: 'Outra' },
];

const INHIRE_USERS = [
  { value: '8793a4f2-51d4-453e-8d16-b06066eec5ff', name: 'Administrador', email: 'admin@ecossis.com.br' },
  { value: 'e5d46b25-4411-4297-9775-5fa2a7c13c52', name: 'Bernardo Frederes Krämer Alcalde', email: 'bernardo.alcalde@ecossis.com.br' },
  { value: '433869d4-3ff6-4360-af14-03416c2cf59d', name: 'Caroline Lopes', email: 'caroline.lopes@ecossis.com.br' },
  { value: 'ef5f175b-8c97-40d4-9b43-4293b26f6aff', name: 'Francisco Soares Talaier', email: 'francisco.talaier@ecossis.com.br' },
  { value: 'be9887d7-d96a-4479-bbcf-41b32a62d1c3', name: 'Gustavo Duval Leite', email: 'gustavo.leite@ecossis.com.br' },
  { value: 'd58b27b5-e49a-4f1e-8ef7-81c084a753db', name: 'Implementação InHire', email: 'produto@byintera.com' },
  { value: 'a7d74cff-60a7-4c6c-a90c-d1b830cec3b7', name: 'Jean da Silva Antônio', email: 'jean.antonio@ecossis.com.br' },
  { value: 'c27ea9e0-2e0f-4506-aa98-eb5539c65f2e', name: 'João Pedro Ribeiro Casaroli', email: 'joao.casaroli@ecossis.com.br' },
  { value: '8a3745af-eca7-4b7a-93fe-6738b27ac123', name: 'Nícolas Borges Morgenstern', email: 'nicolas.morgenstern@ecossis.com.br' },
  { value: 'c2878ff4-17f2-4f6b-9ec5-2a56cfc8cdca', name: 'Nícolas Borges Morgenstern', email: 'nicolas.borges@ecossis.com.br' },
  { value: '6046326a-9afb-46a0-ae05-6fcfbc134458', name: 'Pedro Boni Gasparotto', email: 'pedro.gasparotto@ecossis.com.br' },
  { value: 'dbb0f9d2-d778-4ecf-971a-b973c607b87b', name: 'Projetos', email: 'projetos@ecossis.com.br' },
  { value: '3dd1643f-8871-4a3e-a75f-528d80dfddc1', name: 'Ronaldo Godolphim Plá', email: 'ronaldo.pla@ecossis.com.br' },
  { value: '64fc2a9f-87e4-4818-981d-baa1a2517c03', name: 'Service Account', email: 'service-account-64fc2a9f-87e4-4818-981d-baa1a2517c03@inhire.app' },
  { value: '19b294d9-8592-4eef-9a7e-09d74e0975e2', name: 'Suporte InHire', email: 'suporte@inhire.app' },
  { value: '1984353a-35f1-464a-a2e1-4d9b55510c68', name: 'Tamiris Carvalho', email: 'tamiris.carvalho@ecossis.com.br' },
].map((user) => ({
  value: user.value,
  label: `${user.name} (${user.email})`,
}));

const EQUIPE_INTERNA_OPTIONS = ['Sim', 'Não'];
const TIPO_CONTRATACAO_CUSTOM_OPTIONS = ['Estágio', 'CLT', 'PJ', 'Consultor'];

const WORK_MODEL_TO_OIKOS = {
  presencial: 'Presencial',
  remoto: 'Remoto',
  hibrido: 'Híbrido',
};

const OIKOS_TO_WORK_MODEL = {
  Presencial: 'presencial',
  Remoto: 'remoto',
  Híbrido: 'hibrido',
  Hibrido: 'hibrido',
};

const emptyFormFields = () => FORM_FIELDS.reduce((acc, field) => {
  acc[field.value] = false;
  return acc;
}, {});

const toTimeInputValue = (value) => {
  const raw = String(value || '').trim();
  if (/^\d{2}:\d{2}/.test(raw)) return raw.slice(0, 5);
  return '';
};

const isFilledTime = (value) => /^\d{2}:\d{2}$/.test(toTimeInputValue(value));

export const faixasDoForm = (form = {}) => {
  const mapa = form.horariosPorDia || {};
  return Object.entries(mapa).flatMap(([diaId, lista]) => (
    (Array.isArray(lista) ? lista : []).map((faixa) => ({
      diaSemana_id: Number(diaId),
      inicio: toTimeInputValue(faixa?.inicio),
      fim: toTimeInputValue(faixa?.fim),
    }))
  ));
};

const agruparHorarios = (rows = []) => {
  const mapa = {};
  rows.forEach((row) => {
    const diaId = String(row.diaSemana_id);
    if (!mapa[diaId]) mapa[diaId] = [];
    mapa[diaId].push({
      inicio: toTimeInputValue(row.vagaHorario_horarioInicio),
      fim: toTimeInputValue(row.vagaHorario_horarioFim),
    });
  });
  return mapa;
};

const validarHorariosClt = (form) => {
  const faixas = faixasDoForm(form);
  if (!faixas.length) {
    return 'Informe ao menos um horário de entrada e saída na semana (obrigatório para CLT).';
  }
  if (faixas.some((faixa) => !isFilledTime(faixa.inicio) || !isFilledTime(faixa.fim))) {
    return 'Preencha a entrada e a saída de cada horário.';
  }
  if (faixas.some((faixa) => faixa.inicio >= faixa.fim)) {
    return 'O horário de saída precisa ser depois da entrada.';
  }
  return '';
};

const resumoJornada = (faixas) => {
  const completas = faixas.filter((faixa) => isFilledTime(faixa.inicio) && isFilledTime(faixa.fim));
  if (!completas.length) return { inicio: '', fim: '' };
  const inicios = completas.map((faixa) => faixa.inicio).sort();
  const fins = completas.map((faixa) => faixa.fim).sort();
  return { inicio: inicios[0], fim: fins[fins.length - 1] };
};

const buildInitialForm = (prefill = {}) => {
  const name = prefill.name || '';
  const contractType = Array.isArray(prefill.contractType)
    ? prefill.contractType.filter(Boolean)
    : [];
  return {
    name,
    isConfidential: Boolean(prefill.isConfidential),
    areaATS: prefill.areaATS || '',
    description: prefill.description || '',
    recruiterId: prefill.recruiterId || null,
    managerId: prefill.managerId || null,
    evaluatorIds: Array.isArray(prefill.evaluatorIds) ? prefill.evaluatorIds : [],
    talentSuggestions: Boolean(prefill.talentSuggestions),
    status: prefill.status || 'open',
    positionQty: Number(prefill.positionQty) >= 1 ? Number(prefill.positionQty) : 1,
    positionReason: prefill.positionReason || 'expansion',
    projeto: prefill.projeto || '',
    formacao: prefill.formacao || '',
    atestados: prefill.atestados || '',
    equipeInterna: prefill.equipeInterna || '',
    tipoContratacaoCustom: prefill.tipoContratacaoCustom || '',
    contractType,
    horarioIni: toTimeInputValue(prefill.horarioIni),
    horarioFim: toTimeInputValue(prefill.horarioFim),
    horariosPorDia: prefill.horariosPorDia || {},
    horariosCarregados: false,
    salaryTarget: prefill.salaryTarget || '',
    salaryMin: prefill.salaryMin || '',
    salaryMax: prefill.salaryMax || '',
    salaryCurrency: prefill.salaryCurrency || 'BRL',
    workModel: prefill.workModel || 'presencial',
    locationCountry: prefill.locationCountry || 'BR',
    locationUfId: prefill.locationUfId || null,
    locationState: prefill.locationState || '',
    locationMunId: prefill.locationMunId || null,
    locationCity: prefill.locationCity || '',
    locationAddress: prefill.locationAddress || '',
    locationCep: prefill.locationCep || '',
    locationComplement: prefill.locationComplement || '',
    locationRequired: Boolean(prefill.locationRequired),
    seniority: prefill.seniority || '',
    stages: Array.isArray(prefill.stages) && prefill.stages.length
      ? prefill.stages.map((stage) => ({ ...stage }))
      : DEFAULT_STAGES.map((stage) => ({ ...stage })),
    divulgar: prefill.divulgar !== false,
    postingStatus: prefill.postingStatus || 'published',
    jobBoards: Array.isArray(prefill.jobBoards) ? prefill.jobBoards : [],
    displayName: prefill.displayName || name,
    postingDescription: prefill.postingDescription || '',
    formFields: {
      ...emptyFormFields(),
      curriculum: true,
      salary: true,
      ...(prefill.formFields || {}),
    },
    formRequired: {
      ...emptyFormFields(),
      curriculum: true,
      salary: true,
      ...(prefill.formRequired || {}),
    },
    emailActive: Boolean(prefill.emailActive),
    emailSenderType: prefill.emailSenderType || 'system',
    emailSubject: prefill.emailSubject || '',
    emailBody: prefill.emailBody || '',
    emailTemplateId: prefill.emailTemplateId || '',
  };
};

const MONEY_MASK_BLOCKS = {
  num: {
    mask: Number,
    scale: 2,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: false,
    normalizeZeros: false,
    radix: ',',
    min: 0,
    max: 1000000000,
  },
};

const parseMoneyToNumber = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  let raw = String(value).replace(/[^\d,.-]/g, '').trim();
  if (!raw) return null;
  if (raw.includes(',') && raw.includes('.')) {
    raw = raw.replace(/\./g, '').replace(',', '.');
  } else if (raw.includes(',')) {
    raw = raw.replace(',', '.');
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};

const sortByLabel = (options = []) => (
  [...options].sort((a, b) => String(a.label || '').localeCompare(String(b.label || ''), 'pt-BR'))
);

export const buildInhirePrefillFromPedidoCompra = (data = {}) => {
  const contract = String(data.vaga_tipoContrato || data.vagaContrato || '').trim();
  const workRaw = data.vaga_condicoesTrabalho || data.vagaCondicoesTrabalho || '';
  return {
    name: String(
      data.vaga_nome
      || data.vagaNome
      || data.vaga_cargo
      || data.vagaCargo
      || data.pedidoCompra_desc
      || '',
    ).trim(),
    projeto: String(data.proj_nome || '').trim(),
    formacao: String(data.vaga_formacao || data.vagaFormacao || '').trim(),
    description: String(data.vaga_escopo || data.vagaEscopo || data.vaga_descricao || '').trim(),
    salaryTarget: data.vaga_salarioAlvo ?? '',
    salaryMin: data.vaga_salarioMinimo ?? '',
    salaryMax: data.vaga_salarioMaximo ?? '',
    workModel: OIKOS_TO_WORK_MODEL[workRaw] || 'presencial',
    locationUfId: data.vagaEstado || data.vaga_localidadeEstado || null,
    locationMunId: data.vagaCidade || data.vaga_localidadeCidade || null,
    contractType: contract ? [contract] : [],
    tipoContratacaoCustom: TIPO_CONTRATACAO_CUSTOM_OPTIONS.includes(contract) ? contract : '',
    horarioIni: toTimeInputValue(data.vaga_horarioIni),
    horarioFim: toTimeInputValue(data.vaga_horarioFim),
  };
};

export const mapInhireFormToPedidoCompraFields = (form = {}) => {
  const name = String(form.name || '').trim();
  const description = String(form.description || '').trim();
  const salaryTarget = parseMoneyToNumber(form.salaryTarget);
  const salaryMin = parseMoneyToNumber(form.salaryMin);
  const salaryMax = parseMoneyToNumber(form.salaryMax);
  const contractType = form.tipoContratacaoCustom
    || (Array.isArray(form.contractType) && form.contractType[0])
    || '';
  const condicoesTrabalho = WORK_MODEL_TO_OIKOS[form.workModel] || form.workModel || '';
  const objeto = description || name;
  const faixas = faixasDoForm(form);
  const jornada = contractType === 'CLT'
    ? resumoJornada(faixas)
    : {
      inicio: toTimeInputValue(form.horarioIni),
      fim: toTimeInputValue(form.horarioFim),
    };
  const vagaHorarios = contractType === 'CLT'
    ? faixas
      .filter((faixa) => isFilledTime(faixa.inicio) && isFilledTime(faixa.fim))
      .map((faixa) => ({
        diaSemana_id: faixa.diaSemana_id,
        vagaHorario_horarioInicio: `${faixa.inicio}:00`,
        vagaHorario_horarioFim: `${faixa.fim}:00`,
      }))
    : [];

  return {
    vaga_nome: name,
    vagaNome: name,
    vaga_cargo: name,
    vagaCargo: name,
    vaga_descricao: objeto,
    pedidoCompra_desc: objeto,
    vaga_escopo: description,
    vagaEscopo: description,
    vaga_formacao: form.formacao || '',
    vagaFormacao: form.formacao || '',
    vaga_tipoContrato: contractType,
    vagaContrato: contractType,
    vaga_salarioAlvo: salaryTarget,
    vaga_salarioMinimo: salaryMin,
    vaga_salarioMaximo: salaryMax,
    vagaEstado: form.locationUfId || null,
    vaga_localidadeEstado: form.locationUfId || null,
    vagaCidade: form.locationMunId || null,
    vaga_localidadeCidade: form.locationMunId || null,
    vaga_condicoesTrabalho: condicoesTrabalho,
    vagaCondicoesTrabalho: condicoesTrabalho,
    vaga_requisitos: String(form.atestados || '').trim() || undefined,
    vagaRequisitos: String(form.atestados || '').trim() || undefined,
    vaga_horarioIni: jornada.inicio || null,
    vaga_horarioFim: jornada.fim || null,
    ...(form.horariosCarregados === false ? {} : { vagaHorarios }),
  };
};

const sectionStyle = {
  border: '1px solid #e6e6e6',
  borderRadius: 6,
  padding: '12px 12px 4px',
  marginBottom: 16,
};

const templateStageMeta = () => ({
  createdAt: STAGE_TEMPLATE_AT,
  updatedAt: STAGE_TEMPLATE_AT,
  userId: null,
  userName: 'InHire',
});

export const buildInhireCreateJobBody = (form) => {
  const customFields = INHIRE_CUSTOM_FIELDS
    .filter((field) => String(form[field.key] || '').trim())
    .map((field) => ({
      customFieldId: field.customFieldId,
      name: field.name,
      value: String(form[field.key]).trim(),
      type: field.type,
      order: field.order,
    }));

  const evaluatorIds = (Array.isArray(form.evaluatorIds) ? form.evaluatorIds : [])
    .map((item) => String(item).trim())
    .filter(Boolean);

  const body = {
    acceptedSeniority: [],
    name: String(form.name || '').trim(),
    locationRequired: Boolean(form.locationRequired),
    talentSuggestions: Boolean(form.talentSuggestions),
    isConfidential: Boolean(form.isConfidential),
    evaluatorIds,
    screeningCriteria: [],
    requisitions: [],
    linkedinSettings: { skills: [] },
  };

  if (form.status && form.status !== 'open') body.status = form.status;

  const area = String(form.areaATS || '').trim();
  if (area) body.area = area;

  const description = String(form.description || '').trim();
  if (description) body.description = description;

  if (form.contractType?.length) body.contractType = form.contractType;
  if (form.seniority) body.seniority = form.seniority;

  const recruiterId = form.recruiterId == null ? '' : String(form.recruiterId).trim();
  const managerId = form.managerId == null ? '' : String(form.managerId).trim();
  if (recruiterId) body.recruiterId = recruiterId;
  if (managerId) body.managerId = managerId;

  const salaryTarget = parseMoneyToNumber(form.salaryTarget);
  const salaryMin = parseMoneyToNumber(form.salaryMin);
  const salaryMax = parseMoneyToNumber(form.salaryMax);
  if (salaryTarget != null && Number.isFinite(salaryTarget)) body.salaryTarget = salaryTarget;
  if (salaryMin != null && Number.isFinite(salaryMin)) body.salaryMin = salaryMin;
  if (salaryMax != null && Number.isFinite(salaryMax)) body.salaryMax = salaryMax;

  if (form.workModel !== 'remoto') {
    body.locationCountry = 'BR';
    body.locationState = String(form.locationState || '').trim();
    body.locationCity = String(form.locationCity || '').trim();
    body.locationCep = String(form.locationCep || '').trim();
    const locationAddress = String(form.locationAddress || '').trim();
    const locationComplement = String(form.locationComplement || '').trim();
    if (locationAddress) body.locationAddress = locationAddress;
    if (locationComplement) body.locationComplement = locationComplement;
  }

  if (customFields.length) body.customFields = customFields;

  const qty = Math.max(1, Number(form.positionQty) || 1);
  body.positions = Array.from({ length: qty }, () => ({ reason: form.positionReason }));

  const stages = orderStagesByPhase(form.stages || [])
    .filter((stage) => String(stage.name || '').trim());
  if (stages.length) {
    body.stages = stages.map((stage, index) => {
      const phase = JOB_PHASES.find((item) => item.id === stage.phaseId) || JOB_PHASES[0];
      const phaseOrder = JOB_PHASES.findIndex((item) => item.id === phase.id) + 1;
      const phaseRecord = {
        ...templateStageMeta(),
        id: phase.templatePhaseId,
        name: phase.name,
        order: phaseOrder,
        type: phase.phaseType,
      };
      const item = {
        name: String(stage.name).trim(),
        order: index + 1,
        type: phase.stageType,
        phase: phaseRecord,
      };
      if (stage.templateStageId) {
        Object.assign(item, templateStageMeta(), { id: stage.templateStageId });
      }
      return item;
    });
  }

  return body;
};

export const validateOikosForm = (form) => {
  if (!String(form.name || '').trim()) return 'Informe o nome da vaga.';
  if (!String(form.formacao || '').trim()) return 'Informe a formação profissional.';
  if (!String(form.atestados || '').trim()) return 'Informe os requisitos.';
  if (!form.tipoContratacaoCustom) return 'Informe o tipo de contratação.';
  if (form.tipoContratacaoCustom === 'CLT') {
    const horarioError = validarHorariosClt(form);
    if (horarioError) return horarioError;
  }
  if (form.workModel !== 'remoto') {
    if (!String(form.locationState || '').trim()) return 'Informe o estado.';
    if (!String(form.locationCity || '').trim()) return 'Informe a cidade.';
  }
  return '';
};

export const validateForm = (form) => {
  const oikosError = validateOikosForm(form);
  if (oikosError) return oikosError;
  if (!String(form.projeto || '').trim()) return 'Informe o Projeto.';
  if (!form.positionReason) return 'Informe o motivo das posições.';
  if (!(Number(form.positionQty) >= 1)) return 'Informe a quantidade de posições.';
  if (!form.equipeInterna) return 'Informe se é equipe interna.';
  return '';
};

function MoneyField({ value, onChange }) {
  return (
    <MaskedInput
      unmask
      mask="R$ num"
      blocks={MONEY_MASK_BLOCKS}
      lazy={false}
      value={value === '' || value == null ? '' : String(value)}
      onAccept={(nextValue) => onChange(nextValue ?? '')}
    />
  );
}

function SectionTitle({ children }) {
  return <h6 className="mb-3">{children}</h6>;
}

export default function FormularioAbrirVagaInhireApi({
  active = true,
  prefill = {},
  onChange,
  readOnly = false,
  step = 'all',
  projetoSugerido,
  orcItemId = null,
  inhireJobId = '',
  vagaId = null,
}) {
  const [form, setForm] = React.useState(() => buildInitialForm(prefill));
  const onChangeRef = React.useRef(onChange);
  onChangeRef.current = onChange;
  const projetoEditadoRef = React.useRef(false);
  const [profissoes, setProfissoes] = React.useState([]);
  const [ufs, setUfs] = React.useState([]);
  const [municipios, setMunicipios] = React.useState([]);
  const [diasSemana, setDiasSemana] = React.useState([]);
  const horariosRef = React.useRef(prefill.horariosPorDia || {});
  const horariosEditadosRef = React.useRef(false);
  const horariosCarregadosRef = React.useRef(false);
  const [stageModal, setStageModal] = React.useState(null);
  const wasOpenRef = React.useRef(false);
  const prefillRef = React.useRef(prefill);
  prefillRef.current = prefill;
  const prefillSignature = JSON.stringify(prefill || {});

  React.useEffect(() => {
    if (!active) {
      wasOpenRef.current = false;
      return;
    }
    if (readOnly || !wasOpenRef.current) {
      setForm({
        ...buildInitialForm(prefillRef.current),
        horariosPorDia: horariosRef.current || {},
        horariosCarregados: horariosCarregadosRef.current,
      });
    }
    wasOpenRef.current = true;
  }, [active, readOnly, prefillSignature]);

  React.useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;

    const loadOptions = async () => {
      try {
        const [profRows, ufRows, munRows, diaRows] = await Promise.all([
          selectValues('profissao', 'profissao_id', 'profissao_nome'),
          selectValues('uf', 'uf_id', 'uf_nome', {}, { uf_IBGECod: 'uf_IBGECod', uf_sigla: 'uf_sigla' }),
          selectValues('mun', 'mun_id', 'mun_nome', {}, { uf_IBGECod: 'uf_IBGECod' }),
          selectValues('diaSemana', 'diaSemana_id', 'diaSemana_nome', { diaSemana_ativo: 1 }),
        ]);
        if (cancelled) return;
        setProfissoes(sortByLabel(profRows || []));
        setUfs(sortByLabel(ufRows || []));
        setMunicipios(sortByLabel(munRows || []));
        setDiasSemana((diaRows || []).map((dia) => ({
          id: String(dia.value),
          nome: dia.label,
        })));
      } catch (error) {
        console.error('Erro ao carregar opções da vaga inHire:', error);
        if (!cancelled) notifyError('Não foi possível carregar as listas do formulário.');
      }
    };

    loadOptions();
    return () => { cancelled = true; };
  }, [active]);

  React.useEffect(() => {
    if (!active) return undefined;
    const id = Number(vagaId) || 0;
    let cancelled = false;
    horariosEditadosRef.current = false;

    if (!id) {
      horariosCarregadosRef.current = true;
      setForm((prev) => (prev.horariosCarregados ? prev : { ...prev, horariosCarregados: true }));
      return undefined;
    }

    const loadHorarios = async () => {
      try {
        const res = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'vagaHorario',
          data: { vaga_id: id },
        })}`);
        if (cancelled || horariosEditadosRef.current) {
          if (!cancelled) {
            horariosCarregadosRef.current = true;
            setForm((prev) => ({ ...prev, horariosCarregados: true }));
          }
          return;
        }
        const grouped = agruparHorarios(Array.isArray(res?.data) ? res.data : []);
        horariosRef.current = grouped;
        horariosCarregadosRef.current = true;
        setForm((prev) => ({
          ...prev,
          horariosPorDia: grouped,
          horariosCarregados: true,
        }));
      } catch (error) {
        console.error('Erro ao carregar horários da vaga:', error);
        if (!cancelled) {
          horariosCarregadosRef.current = true;
          setForm((prev) => ({ ...prev, horariosCarregados: true }));
          notifyError('Não foi possível carregar os horários da semana.');
        }
      }
    };

    loadHorarios();
    return () => { cancelled = true; };
  }, [active, vagaId]);

  React.useEffect(() => {
    projetoEditadoRef.current = false;
  }, [orcItemId]);

  React.useEffect(() => {
    if (projetoSugerido === undefined || projetoEditadoRef.current) return;
    const nome = String(projetoSugerido || '');
    setForm((prev) => (prev.projeto === nome ? prev : { ...prev, projeto: nome }));
  }, [projetoSugerido, orcItemId]);

  React.useEffect(() => {
    if (!ufs.length && !municipios.length) return undefined;
    setForm((prev) => {
      let next = prev;
      if (prev.locationUfId && ufs.length) {
        const uf = ufs.find((item) => Number(item.value) === Number(prev.locationUfId));
        const sigla = String(uf?.uf_sigla || '').trim().toUpperCase();
        if (sigla && sigla !== prev.locationState) {
          next = { ...next, locationState: sigla };
        }
      }
      if (prev.locationMunId && municipios.length) {
        const municipio = municipios.find((item) => Number(item.value) === Number(prev.locationMunId));
        if (municipio?.label && municipio.label !== prev.locationCity) {
          next = { ...next, locationCity: municipio.label };
        }
      }
      return next;
    });
    return undefined;
  }, [ufs, municipios]);

  React.useEffect(() => {
    onChangeRef.current?.(form);
  }, [form]);

  const patch = (partial) => setForm((prev) => ({ ...prev, ...partial }));

  const toggleContractType = (value) => {
    setForm((prev) => {
      const selected = prev.contractType.includes(value)
        ? prev.contractType.filter((item) => item !== value)
        : [...prev.contractType, value];
      return { ...prev, contractType: selected };
    });
  };

  const toggleJobBoard = (value) => {
    setForm((prev) => {
      const selected = prev.jobBoards.includes(value)
        ? prev.jobBoards.filter((item) => item !== value)
        : [...prev.jobBoards, value];
      return { ...prev, jobBoards: selected };
    });
  };

  const setFormFieldEnabled = (key, enabled) => {
    setForm((prev) => ({
      ...prev,
      formFields: { ...prev.formFields, [key]: enabled },
      formRequired: {
        ...prev.formRequired,
        [key]: enabled ? prev.formRequired[key] : false,
      },
    }));
  };

  const setFormFieldRequired = (key, required) => {
    setForm((prev) => ({
      ...prev,
      formRequired: { ...prev.formRequired, [key]: required && prev.formFields[key] },
    }));
  };

  const openCreateStage = (phaseId) => {
    setStageModal({ mode: 'create', stageId: null, name: '', phaseId });
  };

  const openEditStage = (stage) => {
    setStageModal({
      mode: 'edit',
      stageId: stage.id,
      name: stage.name,
      phaseId: stage.phaseId,
    });
  };

  const removeStage = (stageId) => {
    setForm((prev) => ({
      ...prev,
      stages: prev.stages.filter((stage) => stage.id !== stageId),
    }));
  };

  const saveStageModal = () => {
    const name = String(stageModal?.name || '').trim();
    if (!name || !stageModal?.phaseId) return;

    setForm((prev) => {
      if (stageModal.mode === 'edit') {
        const current = prev.stages.find((stage) => stage.id === stageModal.stageId);
        if (!current) return prev;
        const updated = { ...current, name, phaseId: stageModal.phaseId };
        if (current.phaseId === stageModal.phaseId) {
          return {
            ...prev,
            stages: prev.stages.map((stage) => (stage.id === updated.id ? updated : stage)),
          };
        }
        return {
          ...prev,
          stages: [
            ...prev.stages.filter((stage) => stage.id !== updated.id),
            updated,
          ],
        };
      }

      return {
        ...prev,
        stages: [
          ...prev.stages,
          { id: `stage-${Date.now()}`, name, phaseId: stageModal.phaseId },
        ],
      };
    });
    setStageModal(null);
  };

  const selectedUf = ufs.find((uf) => Number(uf.value) === Number(form.locationUfId)) || null;
  const filteredMunicipios = selectedUf?.uf_IBGECod
    ? municipios.filter((municipio) => String(municipio.uf_IBGECod) === String(selectedUf.uf_IBGECod))
    : [];
  const orderedStages = orderStagesByPhase(form.stages);
  const showLocation = form.workModel !== 'remoto';
  const showOikos = step === 'all' || step === 'oikos';
  const showInhire = step === 'all' || step === 'inhire';

  return (
    <div style={readOnly ? { pointerEvents: 'none' } : undefined}>

        {showOikos && (
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Nome *</Label>
                <Input
                  value={form.name}
                  onChange={(event) => patch({
                    name: event.target.value,
                    displayName: form.displayName === form.name ? event.target.value : form.displayName,
                  })}
                />
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <Label>Descrição</Label>
                <Input
                  type="textarea"
                  rows={3}
                  value={form.description}
                  onChange={(event) => patch({ description: event.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Formação profissional *</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecione"
                  isClearable
                  isSearchable
                  options={profissoes}
                  value={profissoes.find((profissao) => profissao.label === form.formacao) || null}
                  onChange={(option) => patch({ formacao: option?.label || '' })}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Requisitos *</Label>
                <Input value={form.atestados} onChange={(event) => patch({ atestados: event.target.value })} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Tipo de contratação *</Label>
                <Input
                  type="select"
                  value={form.tipoContratacaoCustom}
                  onChange={(event) => patch({ tipoContratacaoCustom: event.target.value })}
                >
                  <option value="">Selecione</option>
                  {TIPO_CONTRATACAO_CUSTOM_OPTIONS.map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            {form.tipoContratacaoCustom === 'CLT' ? (
              <Col md={12}>
                <FormGroup>
                  <Label>Horários da semana *</Label>
                  <p className="text-muted small mb-2">
                    Inclua cada faixa do dia. Na segunda-feira, por exemplo, 08:00–12:00 e 13:00–17:00.
                  </p>
                  <VagaHorarioKanban
                    dias={diasSemana}
                    horariosPorDia={form.horariosPorDia || {}}
                    readOnly={readOnly}
                    onChange={(horariosPorDia) => {
                      horariosEditadosRef.current = true;
                      horariosRef.current = horariosPorDia;
                      horariosCarregadosRef.current = true;
                      patch({ horariosPorDia, horariosCarregados: true });
                    }}
                  />
                </FormGroup>
              </Col>
            ) : (
              <>
                <Col md={3}>
                  <FormGroup>
                    <Label>Horário de início da jornada</Label>
                    <Input
                      type="time"
                      value={form.horarioIni || ''}
                      onChange={(event) => patch({ horarioIni: event.target.value || '' })}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Horário de fim da jornada</Label>
                    <Input
                      type="time"
                      value={form.horarioFim || ''}
                      onChange={(event) => patch({ horarioFim: event.target.value || '' })}
                    />
                  </FormGroup>
                </Col>
              </>
            )}
            <Col md={4}>
              <FormGroup>
                <Label>Salário máximo</Label>
                <MoneyField
                  value={form.salaryMax}
                  onChange={(salaryMax) => patch({ salaryMax })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Salário mínimo</Label>
                <MoneyField
                  value={form.salaryMin}
                  onChange={(salaryMin) => patch({ salaryMin })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Salário alvo</Label>
                <MoneyField
                  value={form.salaryTarget}
                  onChange={(salaryTarget) => patch({ salaryTarget })}
                />
              </FormGroup>
            </Col>
          </Row>
        )}

        {showInhire && (
        <div style={sectionStyle}>
          <SectionTitle>Detalhes no inHire</SectionTitle>
          <FormGroup check className="mb-3">
            <Label check>
              <Input
                type="checkbox"
                checked={form.isConfidential}
                onChange={(event) => patch({ isConfidential: event.target.checked })}
              />
              {' '}Esta vaga é confidencial?
            </Label>
          </FormGroup>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>Área</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecione"
                  isClearable
                  options={AREA_OPTIONS}
                  value={AREA_OPTIONS.find((area) => area.value === form.areaATS) || null}
                  onChange={(option) => patch({ areaATS: option?.value || '' })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Recrutador(a) Responsável</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecione"
                  isClearable
                  isSearchable
                  options={INHIRE_USERS}
                  value={INHIRE_USERS.find((user) => user.value === form.recruiterId) || null}
                  onChange={(option) => patch({ recruiterId: option?.value ?? null })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Gestor(a) Responsável</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecione"
                  isClearable
                  isSearchable
                  options={INHIRE_USERS}
                  value={INHIRE_USERS.find((user) => user.value === form.managerId) || null}
                  onChange={(option) => patch({ managerId: option?.value ?? null })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Status da vaga</Label>
                <Input
                  type="select"
                  value={form.status}
                  onChange={(event) => patch({ status: event.target.value })}
                >
                  {JOB_STATUS_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={8}>
              <FormGroup>
                <Label>Avaliador(a) Responsável</Label>
                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecione"
                  isClearable
                  isSearchable
                  isMulti
                  options={INHIRE_USERS}
                  value={INHIRE_USERS.filter((user) => (
                    (form.evaluatorIds || []).includes(user.value)
                  ))}
                  onChange={(options) => patch({
                    evaluatorIds: (options || []).map((option) => option.value),
                  })}
                />
              </FormGroup>
            </Col>
            <Col md={4} className="d-flex align-items-center">
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={form.talentSuggestions}
                    onChange={(event) => patch({ talentSuggestions: event.target.checked })}
                  />
                  {' '}Sugestões automáticas de talentos
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </div>
        )}

        {showInhire && (
        <div style={sectionStyle}>
          <SectionTitle>Posições</SectionTitle>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>Quantidade de posições</Label>
                <Input
                  type="number"
                  min={1}
                  value={form.positionQty}
                  onChange={(event) => patch({ positionQty: event.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Motivo das posições</Label>
                <Input
                  type="select"
                  value={form.positionReason}
                  onChange={(event) => patch({ positionReason: event.target.value })}
                >
                  {POSITION_REASONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </div>
        )}

        {showInhire && (
        <div style={sectionStyle}>
          <SectionTitle>Campos personalizados</SectionTitle>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Projeto *</Label>
                <Input
                  value={form.projeto}
                  onChange={(event) => {
                    projetoEditadoRef.current = true;
                    patch({ projeto: event.target.value });
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>Equipe interna? *</Label>
                <Input
                  type="select"
                  value={form.equipeInterna}
                  onChange={(event) => patch({ equipeInterna: event.target.value })}
                >
                  <option value="">Selecione</option>
                  {EQUIPE_INTERNA_OPTIONS.map((option) => (
                    <option key={option} value={option}>{option}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={12}>
              <Label>Tipo de contratação</Label>
              <div className="d-flex flex-wrap mb-3">
                {CONTRACT_TYPES.map((value) => (
                  <FormGroup check key={value} className="mr-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={form.contractType.includes(value)}
                        onChange={() => toggleContractType(value)}
                      />
                      {' '}{value}
                    </Label>
                  </FormGroup>
                ))}
              </div>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>Moeda</Label>
                <Input
                  type="select"
                  value={form.salaryCurrency}
                  onChange={(event) => patch({ salaryCurrency: event.target.value })}
                >
                  <option value="BRL">BRL</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </div>
        )}

        {(showOikos || showInhire) && (
        <div style={sectionStyle}>
          <SectionTitle>Localização</SectionTitle>
          {showOikos && (
          <>
          <div className="mb-3">
            {['presencial', 'remoto', 'hibrido'].map((value) => (
              <Button
                key={value}
                type="button"
                size="sm"
                className="mr-2"
                color={form.workModel === value ? 'primary' : 'secondary'}
                outline={form.workModel !== value}
                onClick={() => patch({ workModel: value })}
              >
                {value === 'presencial' ? 'Presencial' : value === 'remoto' ? 'Remoto' : 'Híbrido'}
              </Button>
            ))}
          </div>
          {showLocation && (
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Estado *</Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione"
                    isClearable
                    isSearchable
                    options={ufs}
                    value={selectedUf}
                    onChange={(option) => patch({
                      locationUfId: option?.value ?? null,
                      locationState: String(option?.uf_sigla || '').trim().toUpperCase(),
                      locationMunId: null,
                      locationCity: '',
                    })}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Cidade *</Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder={form.locationUfId ? 'Selecione' : 'Selecione o estado'}
                    isClearable
                    isSearchable
                    isDisabled={!form.locationUfId}
                    options={filteredMunicipios}
                    value={filteredMunicipios.find((municipio) => (
                      Number(municipio.value) === Number(form.locationMunId)
                    )) || null}
                    onChange={(option) => patch({
                      locationMunId: option?.value ?? null,
                      locationCity: option?.label || '',
                    })}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
          </>
          )}
          {showInhire && showLocation && (
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Endereço</Label>
                  <Input
                    value={form.locationAddress}
                    onChange={(event) => patch({ locationAddress: event.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>CEP</Label>
                  <Input
                    value={form.locationCep}
                    onChange={(event) => patch({ locationCep: event.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Complemento</Label>
                  <Input
                    value={form.locationComplement}
                    onChange={(event) => patch({ locationComplement: event.target.value })}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
          {showInhire && (
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                checked={form.locationRequired}
                onChange={(event) => patch({ locationRequired: event.target.checked })}
              />
              {' '}Solicitar localização do candidato na inscrição
            </Label>
          </FormGroup>
          )}
        </div>
        )}

        {showInhire && (
        <>
        <div style={sectionStyle}>
          <SectionTitle>Senioridade</SectionTitle>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>Senioridade da vaga</Label>
                <Input
                  type="select"
                  value={form.seniority}
                  onChange={(event) => patch({ seniority: event.target.value })}
                >
                  <option value="">Selecione</option>
                  {SENIORITY_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </div>

        {!readOnly && (
        <div style={sectionStyle}>
          <SectionTitle>Etapas da vaga</SectionTitle>
          <p className="text-muted mb-3" style={{ fontSize: 13 }}>
            As fases são fixas. Cada fase pode ter várias etapas.
          </p>
          {JOB_PHASES.map((phase) => {
            const stagesInPhase = orderedStages.filter((stage) => stage.phaseId === phase.id);
            return (
              <div
                key={phase.id}
                style={{
                  background: '#f4f5f7',
                  borderRadius: 8,
                  padding: '12px 14px',
                  marginBottom: 10,
                }}
              >
                <div style={{ fontWeight: 600, marginBottom: 10 }}>{phase.name}</div>
                <div className="d-flex flex-wrap align-items-center">
                  {stagesInPhase.map((stage) => {
                    const order = orderedStages.findIndex((item) => item.id === stage.id) + 1;
                    return (
                      <div
                        key={stage.id}
                        className="d-flex align-items-center mr-2 mb-2"
                        style={{
                          background: '#fff',
                          border: '1px solid #e6e6e6',
                          borderRadius: 8,
                          padding: '4px 8px',
                        }}
                      >
                        <span className="text-muted mr-2" style={{ fontSize: 12 }}>{order}</span>
                        <span className="mr-2">{stage.name}</span>
                        <Button
                          type="button"
                          color="link"
                          size="sm"
                          className="p-0 mr-2"
                          onClick={() => openEditStage(stage)}
                        >
                          Editar
                        </Button>
                        <Button
                          type="button"
                          color="link"
                          size="sm"
                          className="p-0 text-danger"
                          onClick={() => removeStage(stage.id)}
                        >
                          Excluir
                        </Button>
                      </div>
                    );
                  })}
                  <Button
                    type="button"
                    color="primary"
                    outline
                    size="sm"
                    className="mb-2"
                    onClick={() => openCreateStage(phase.id)}
                  >
                    + Criar nova etapa
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
        )}

        <div style={sectionStyle}>
          <SectionTitle>Divulgação da vaga</SectionTitle>
          <div className="mb-3">
            <span className="mr-2">Você quer divulgar a vaga?</span>
            <Button
              type="button"
              size="sm"
              color={form.divulgar ? 'primary' : 'secondary'}
              outline={!form.divulgar}
              className="mr-2"
              onClick={() => patch({ divulgar: true })}
            >
              Sim
            </Button>
            <Button
              type="button"
              size="sm"
              color={!form.divulgar ? 'primary' : 'secondary'}
              outline={form.divulgar}
              onClick={() => patch({ divulgar: false, jobBoards: [] })}
            >
              Não
            </Button>
          </div>
          {form.divulgar && (
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label>Quem pode ver essa vaga?</Label>
                  <Input
                    type="select"
                    value={form.postingStatus}
                    onChange={(event) => patch({ postingStatus: event.target.value })}
                  >
                    {POSTING_STATUS_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={12}>
                <Label>Plataformas</Label>
                <div className="d-flex flex-wrap mb-3">
                  {JOB_BOARDS.map((board) => (
                    <FormGroup check key={board.value} className="mr-3">
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={form.jobBoards.includes(board.value)}
                          onChange={() => toggleJobBoard(board.value)}
                        />
                        {' '}{board.label}
                      </Label>
                    </FormGroup>
                  ))}
                </div>
              </Col>
            </Row>
          )}
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Nome da vaga para divulgação{form.divulgar ? ' *' : ''}</Label>
                <Input
                  value={form.displayName}
                  onChange={(event) => patch({ displayName: event.target.value })}
                />
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <Label>Informações da vaga (HTML)</Label>
                <Input
                  type="textarea"
                  rows={6}
                  value={form.postingDescription}
                  onChange={(event) => patch({ postingDescription: event.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Label>Formulário de inscrição</Label>
          {FORM_FIELDS.map((field) => (
            <div key={field.value} className="d-flex align-items-center mb-2">
              <FormGroup check className="mb-0 mr-4">
                <Label check>
                  <Input
                    type="checkbox"
                    checked={Boolean(form.formFields[field.value])}
                    onChange={(event) => setFormFieldEnabled(field.value, event.target.checked)}
                  />
                  {' '}{field.label}
                </Label>
              </FormGroup>
              <FormGroup check className="mb-0">
                <Label check>
                  <Input
                    type="checkbox"
                    disabled={!form.formFields[field.value]}
                    checked={Boolean(form.formRequired[field.value])}
                    onChange={(event) => setFormFieldRequired(field.value, event.target.checked)}
                  />
                  {' '}Tornar obrigatório
                </Label>
              </FormGroup>
            </div>
          ))}
        </div>

        <div style={sectionStyle}>
          <SectionTitle>Confirmação de inscrição</SectionTitle>
          <div className="mb-3">
            <span className="mr-2">Deseja configurar um e-mail de confirmação?</span>
            <Button
              type="button"
              size="sm"
              color={form.emailActive ? 'primary' : 'secondary'}
              outline={!form.emailActive}
              className="mr-2"
              onClick={() => patch({ emailActive: true })}
            >
              Sim
            </Button>
            <Button
              type="button"
              size="sm"
              color={!form.emailActive ? 'primary' : 'secondary'}
              outline={form.emailActive}
              onClick={() => patch({ emailActive: false })}
            >
              Não
            </Button>
          </div>
          {form.emailActive && (
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label>Remetente</Label>
                  <Input
                    type="select"
                    value={form.emailSenderType}
                    onChange={(event) => patch({ emailSenderType: event.target.value })}
                  >
                    <option value="system">Sistema (noreply)</option>
                    <option value="personal">Recrutador da vaga</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label>ID do template (opcional)</Label>
                  <Input
                    value={form.emailTemplateId}
                    onChange={(event) => patch({ emailTemplateId: event.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label>Assunto do e-mail *</Label>
                  <Input
                    value={form.emailSubject}
                    onChange={(event) => patch({ emailSubject: event.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label>Corpo da mensagem *</Label>
                  <Input
                    type="textarea"
                    rows={5}
                    value={form.emailBody}
                    onChange={(event) => patch({ emailBody: event.target.value })}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
        </div>
        {readOnly && showInhire && inhireJobId ? (
          <div style={{ ...sectionStyle, pointerEvents: 'auto' }}>
            <SectionTitle>Candidatos da vaga</SectionTitle>
            <InhireVagaKanban jobId={inhireJobId} active={active} />
          </div>
        ) : null}
        </>
        )}

    <Modal isOpen={Boolean(stageModal)} toggle={() => setStageModal(null)}>
      <ModalHeader toggle={() => setStageModal(null)}>
        {stageModal?.mode === 'edit' ? 'Editar Etapa' : 'Criar Etapa'}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Nome da etapa</Label>
          <Input
            placeholder="Escreva o nome da etapa"
            value={stageModal?.name || ''}
            onChange={(event) => setStageModal((prev) => (
              prev ? { ...prev, name: event.target.value } : prev
            ))}
          />
        </FormGroup>
        <FormGroup>
          <Label>Fase da etapa</Label>
          <Input
            type="select"
            value={stageModal?.phaseId || JOB_PHASES[0].id}
            onChange={(event) => setStageModal((prev) => (
              prev ? { ...prev, phaseId: event.target.value } : prev
            ))}
          >
            {JOB_PHASES.map((phase) => (
              <option key={phase.id} value={phase.id}>{phase.name}</option>
            ))}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        {stageModal?.mode === 'edit' && (
          <Button
            color="danger"
            outline
            className="mr-auto"
            onClick={() => {
              removeStage(stageModal.stageId);
              setStageModal(null);
            }}
          >
            Excluir
          </Button>
        )}
        <Button
          color="primary"
          disabled={!String(stageModal?.name || '').trim()}
          onClick={saveStageModal}
        >
          Salvar
        </Button>
      </ModalFooter>
    </Modal>
    </div>
  );
}
